module.exports = __webpack_public_path__ + "img/logo.0ed7fb73.png";